<template>
	<div class="wrappers">
		<div class="ct2_a">
			<div class="appl">
				<div class="tbn">
					<div class="mt bbda">消息中心</div>
					<div style="margin: 0;">
						<div class="li" @click="liclioc(1)" :class="[listquery.type==1?'lis lisss':'']">评论<div class="hongdian" v-if="notice.type01>0"></div></div>
						<div class="li" @click="liclioc(2)" :class="[listquery.type==2?'lis lisss':'']">博客<div class="hongdian" v-if="notice.type02>0"></div></div>
						<div class="li" @click="liclioc(3)" :class="[listquery.type==3?'lis lisss':'']">帖子<div class="hongdian" v-if="notice.type03>0"></div></div>
						<div class="li liss" @click="liclioc(4)" :class="[listquery.type==4?'lis liss':'']">系统通知<div class="hongdian" v-if="notice.type04>0"></div></div>
					</div>
				</div>
			</div>
		    
			<div class="mn">
				<el-button type="primary" @click="user_xiaoxi_deleall">清空所有消息</el-button>
				<div class="xiaoxi" v-for="(item,i) in list" :key="i">
					<div class="xiaoxi01">
						<img :src="item.headimgurl" alt="" v-if="listquery.type!=4">
						<img src="../../../../assets/logo.png" alt="" v-if="listquery.type==4">
					</div>
					<div class="xiaoxi02">
						<div class="xia01">
							<span v-if="listquery.type!=4">{{item.nickname}}</span>
							<span v-if="listquery.type==4">领驭框架</span>
							<div class="xia01s" v-if="listquery.type==1">回复了你的帖子</div>
							<div class="xia01s" v-if="listquery.type==2">发布了新的博客</div>
							<div class="xia01s" v-if="listquery.type==3">发布了新的帖子</div>
							<div class="xia01s" v-if="listquery.type==4">发布了新的{{
								item.newstype==1?'新闻':
								item.newstype==2?'资源':'活动公告'
							}}</div>
						</div>
					<!-- 	<div class="xia02">
							{{item.pingcontent}}
						</div> -->
						<div class="xia02" @click="poturl(item)">
							{{item.protitle}}
						</div>
					</div>
					<div class="xiaoxi03">
						<i class="el-icon-delete" style="cursor: pointer;" @click="user_xiaoxi_delete(item.id)"></i>
						<div class="xiaoxi03">{{item.createTime}}</div>
					</div>
				</div>
				<!-- 分页 -->
				<div class="pagination-container" style="margin-top: 20px;">
				  <el-pagination
				    :current-page="listquery.page"
				    :page-sizes="[4]"
				    :page-size="listquery.limit"
				    :total="total"
				    background layout="total, sizes, prev, pager, next, jumper"
				    @size-change="handleSizeChanges"
				    @current-change="handleCurrentChanges"
				  />
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
    import { mapGetters } from 'vuex'
	import { user_xiaoxi_list,user_xiaoxi_delete,user_xiaoxi_deleall } from "@/api/user"
	export default {
		data(){
			return{
				listquery:{
					page:1,
					limit:4,
					type:1,//1评论 2博客 3帖子 4系统通知
				},
				loading:false,
				total:0,
				list:[]
			}
		},
		computed: mapGetters([
			"notice"
		]),
		props:{
			name:{
				type:String,
				default:'0'
			},
			type:{
				type:Number,
				default:1
			}
		},
		watch:{
			type(e){
				this.listquery.type = e
				this.listquery.page = 1
			},
			name(e){
				if(e=='ten'){
					this.$store.dispatch('user/noticeinfo');//获取消息
					this.user_xiaoxi_list();
				}
			}
		},
		methods:{
			liclioc(type){
				this.listquery.type = type
				this.listquery.page = 1
				this.user_xiaoxi_list();
			},
			user_xiaoxi_deleall(){
				this.$confirm('是否清空消息?', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(()=>{
						const loading = this.$loading({
						  lock: true,
						  text: '清空中',
						  spinner: 'el-icon-loading',
						  background: 'rgba(0, 0, 0, 0.7)'
						});
						user_xiaoxi_deleall({
							type:this.listquery.type
						}).then(()=>{
							loading.close();
							this.$message.success("成功");
							this.user_xiaoxi_list();
						}).catch(()=>{
							loading.close();
						})
					})
			},
			user_xiaoxi_delete(id){
				 this.$confirm('是否删除此条消息?', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(()=>{
						const loading = this.$loading({
						  lock: true,
						  text: '删除中',
						  spinner: 'el-icon-loading',
						  background: 'rgba(0, 0, 0, 0.7)'
						});
						user_xiaoxi_delete({
							id:id
						}).then(()=>{
							loading.close();
							this.$message.success("成功");
							this.user_xiaoxi_list();
						}).catch(()=>{
							loading.close();
						})
					})
			},
			user_xiaoxi_list(){
				this.loading = true
				this.list = [];
				user_xiaoxi_list(this.listquery).then(res=>{
					this.loading = false
					console.log("消息成功",res.data);
					this.list = res.data.list
					this.total = res.data.total
					this.$store.dispatch('user/noticeinfo');//获取消息
				}).catch(()=>{
					this.loading = false
				})
			},
			//点击产品跳转到相应的页面
			poturl(item){
				if(item.type==1 || item.type==3){
					this.$router.push({
						path:"/forumdetail",
						query:{
							id:item.proid
						}
					})
				}
				if(item.type==2){
					this.$router.push({
						path:"/bokedetail",
						query:{
							id:item.proid
						}
					})
				}
				if(item.type==4){
					this.$router.push({
						path:"/newsdetail",
						query:{
							id:item.proid
						}
					})
				}
			},
			//下一页上一页操作
			handleSizeChanges(val) {//条数
			  this.listquery.limit = val
			  this.listquery();
			  
			},
			handleCurrentChanges(val) {//列数
			  this.listquery.page = val
			 this.listquery();
			},
		}
	}
</script>

<style lang="scss" scoped>
	.xiaoxi02{
		width: 60%;
		margin-left: 20px;
		cursor: pointer;
		.xia03{
			color: #333;
			font-size: 14px;
			margin-top: 10px;
			white-space:nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}
		.xia02{
			color: #333;
			font-size: 14px;
			font-weight: bold;
			margin-top: 10px;
			white-space:nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}
		.xia02:hover{
			text-decoration: underline;
		}
		.xia01{
			display: flex;
			align-items: center;
			color: #333;
			font-size: 14px;
			.xia01s{
				color: #666;
				font-size: 14px;
				margin-left: 5px;
			}
		}
	}
	.xiaoxi03{
		margin-left: auto;
		padding-top: 10px;
		color: #666;
		font-size: 14px;
		text-align: right;
	}
	.xiaoxi{
		padding: 24px 0;
		border-bottom: 1px solid #f0f0f2;
		display: flex;
		.xiaoxi01{
			width: 42px;
			height: 42px;
			img{
				width: 100%;
				height: 100%;
				border-radius: 50%;
			}
		}
	}
	.lisss{
		.hongdian{
			width: 5px;
			height: 5px;
			background: #fc5531;
			border-radius: 50%;
			position: absolute;
			left: 37px!important;
			top: 11px;
		}
	}
	.liss{
		.hongdian{
			left: 60px!important;
		}
	}
	.li{
		.hongdian{
			width: 5px;
			height: 5px;
			background: #fc5531;
			border-radius: 50%;
			position: absolute;
			left: 30px;
			top: 11px;
		}
	}
	.mn{
		display: inline;
		    float: right;
		    width: 1010px;
		    margin-right: 25px;
		    padding-top: 20px;
	}
	.span{
		cursor: pointer;
	}
	.span:hover{
		color: #FFA07A;
	}
	.mt{
		padding: 10px;
		font-size: 16px;
	}
	.ct2_a{
		width: 100%;
		border: 1px solid #f0f0f0;
		background: #fff url("../../../../assets/vlineb.png") repeat-y 0 0;
		width: auto;
		min-height: 750px;
		.appl{
			float: left;
			    overflow: hidden;
			    margin-bottom: 10px;
			    padding: 6px 10px;
			    width: 117px;
			.tbn{
				margin: -6px -10px 0;
				.li{
					width: 100%;
					height: 40px;
					line-height: 40px;
					border-bottom: 1px dashed #CCC;
					font-size: 14px;
					margin: 0 10px;
					color: #333;
					cursor: pointer;
					position: relative;
				}
				.lis{
					    margin: -1px 0 0;
					    padding: 0 10px 0 9px;
					    border-top: 1px solid #f0f0f0;
					    border-bottom-style: solid;
					    background: #FFF;
				}
				.li:hover{
					color: #FFA07A;
				}
				.bbda{
					border-bottom: 1px dashed #f0f0f0;
					font-weight: bold;
				}
			}
		}
	}
	.wrapper{
		width: 1200px;
		margin: 0 auto;
		padding-top: 30px;
		.wrappers{
			width: 100%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/neirong/new/noice.vue